import { LeaderboardStatusType } from '../types/leaderboard-status-type';
import { GamificationProfileDto } from '../types/GamificationProfileDto';
import { Action } from '@ngrx/store';
import { PayloadAction } from '../types/payload-action';
import {
  GET_GAMIFICATION_PROFILE,
  STORE_GAMIFICATION_BADGES,
  STORE_GAMIFICATION_LEADERBOARD,
  STORE_GAMIFICATION_PROFILE,
} from '../actions/gamification.actions';
import { GamificationLeaderboardDto } from '../types/GamificationLeaderboardDto';
import { GamificationBadgeDto } from '../types/GamificationBadgeDto';

export interface GamificationState {
  leaderboardStatus: LeaderboardStatusType;

  leaderboard: GamificationLeaderboardDto;

  weeklyBadges: GamificationBadgeDto[];

  gamificationProfile: GamificationProfileDto;
}

const initialState: GamificationState = {
  leaderboardStatus: undefined,

  leaderboard: undefined,

  weeklyBadges: undefined,

  gamificationProfile: undefined,
};

export function gamificationReducer(
  state: GamificationState = initialState,
  action: Action
) {
  return {
    leaderboardStatus: leaderboardStatusReducer(
      state.leaderboardStatus,
      action
    ),
    leaderboard: leaderboardReducer(state.leaderboard, action),
    weeklyBadges: badgesReducer(state.weeklyBadges, action),
    gamificationProfile: gamificationProfileReducer(
      state.gamificationProfile,
      action
    ),
  };
}

export function leaderboardStatusReducer(
  state: LeaderboardStatusType,
  action: PayloadAction<any>
) {
  switch (action.type) {
    case GET_GAMIFICATION_PROFILE:
      return state === LeaderboardStatusType.ERROR ? undefined : state;
    case STORE_GAMIFICATION_PROFILE:
      return action.payload
        ? state
        : action.payload === null
        ? LeaderboardStatusType.INITIAL
        : LeaderboardStatusType.ERROR;
    case STORE_GAMIFICATION_LEADERBOARD:
      return action.payload
        ? LeaderboardStatusType.ACTIVE
        : action.payload === null
        ? LeaderboardStatusType.INACTIVE
        : LeaderboardStatusType.ERROR;
    default:
      return state;
  }
}

export function leaderboardReducer(
  state: GamificationLeaderboardDto,
  action: PayloadAction<any>
) {
  switch (action.type) {
    case STORE_GAMIFICATION_PROFILE:
      return action.payload ? state : undefined;
    case STORE_GAMIFICATION_LEADERBOARD:
      return action.payload;
    default:
      return state;
  }
}

export function badgesReducer(
  state: GamificationBadgeDto[],
  action: PayloadAction<any>
) {
  switch (action.type) {
    case STORE_GAMIFICATION_PROFILE:
      return action.payload ? state : undefined;
    case STORE_GAMIFICATION_BADGES:
      return action.payload;
    default:
      return state;
  }
}

export function gamificationProfileReducer(
  state: GamificationProfileDto,
  action: PayloadAction<any>
) {
  switch (action.type) {
    case STORE_GAMIFICATION_PROFILE:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/reducers/gamification-reducer.ts